import collectionList from "./collectionList";
import iconPicker from "./iconPicker";
import form from "./form";
import wrapper from "./wrapper";

export default `
  ${collectionList}
  ${iconPicker}
  ${form}
  ${wrapper}
`;
